<template>
    <div id="FormImage" :class="`form-image-align-${align}`">
        <img :src="asset" :style="{ width: width + 'px', height: height + 'px' }" />
    </div>
</template>
<script>
export default {
    name: "FormImage",
    props: {
        align: String,
        item: Object,
        asset: String,
        width: String,
        height: String,
        formId: {
            type: String,
            required: true,
        },
        order: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            localAlign: this.align || "center",
        };
    },
};
</script>
<style lang="scss" scoped>
#FormImage {
    .form-image {
        display: flex;
        justify-content: center;
        max-width: 700px;
    }
}

.form-image-align-left {
    display: flex !important;
    justify-content: flex-start !important;
    max-width: 700px;
}

.form-image-align-right {
    display: flex !important;
    justify-content: flex-end !important;
    max-width: 700px;
}
</style>